export enum Currency {
    USD = 'USD',
    NIO = 'NIO',
}
